// First-wins execution guard for Rspack entry packs.
//
// The asset rescue watchdog (assetRescueWatchdog.inline.js) injects GCS copies
// of the pack scripts when the CDN copies stall. A stalled CDN copy can still
// finish loading minutes later, and removing its tag does not reliably cancel
// the in-flight fetch — so both copies may execute. Both are byte-identical
// builds carrying this guard: whichever executes first claims the pack name and
// the loser no-ops instead of double-booting React/Sentry/listeners.
//
// The claim registry doubles as the watchdog's boot signal: a non-empty
// window.__m8PackExecutions means the origin currently serving the packs is
// reachable and no rescue is needed.
export const claimPackExecution = (packName) => {
  try {
    /* eslint-disable no-underscore-dangle */
    window.__m8PackExecutions = window.__m8PackExecutions || {};
    if (window.__m8PackExecutions[packName]) return false;
    window.__m8PackExecutions[packName] = true;
    /* eslint-enable no-underscore-dangle */
    return true;
  } catch {
    // No window / storage of any kind: fail open so the app still boots.
    return true;
  }
};

export default claimPackExecution;
